export enum ContentHeaderTab {
  salesPartner = "salesPartner",
  additionalData = "additionalData"
}

export enum OrderErrorCode {
  outDated = "outdated"
}

export enum TypeOfApplyAll {
  Successfully = "success",
  UnSuccessfully = "error"
}

export enum ModeUpdate {
  ApplyAll = "apply_all",
  SaveDraft = "save_draft",
  AutoSaveDraft = "auto_save_draft",
  Submit = "submit"
}
